import React, { PureComponent } from 'react'
import { FormControl, Typography, Grid } from '@material-ui/core'

import ForwardRefHOC from '../../containers/HOC/ForwardRefHOC'
import ModalDialog from '../common/ModalDialog'

class DocusignNotificationModal extends PureComponent {
  constructor(props) {
    super(props)
  }

  render() {
    const { forwardedRef, docuRes = {} } = this.props

    return (
      <ModalDialog
        title={docuRes.notificationTitle || ''}
        ref={forwardedRef}
        onConfirm={this.props.onClose}
        onClose={this.props.onClose}
        // onOpen={this.onOpen}
        cancelText={docuRes.notificationButton || ''}
        hideSave={true}
      >
        <Typography
          variant="subheading"
          style={{ fontWeight: 'bold', textAlign: 'center', fontSize: '1.5rem' }}
        >
          {docuRes.notificationHeader || ''}
        </Typography>
        <br />
        <Typography variant="subheading" style={{ fontWeight: 'bold' }}>
          {docuRes.notificationSubHeader || ''}
        </Typography>
        <br />
        <Typography variant="subheading">{docuRes.notificationBody || ''}</Typography>
        <br />
        <br />
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography variant="subheading" style={{ fontWeight: 'bold', textAlign: 'center' }}>
              Need more Help? Reach out!
            </Typography>
            <hr style={{ margin: '10px 10%' }} />
          </Grid>
          <Grid
            container
            item
            xs={12}
            style={{ display: 'flex', justifyContent: 'center', margin: '5px 0px' }}
          >
            <Grid item xs={4}>
              <Typography variant="subheading">
                {' '}
                <b>E-mail</b>{' '}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="subheading">{docuRes.supportEmail || ''}</Typography>
            </Grid>
          </Grid>
          <Grid
            container
            item
            xs={12}
            style={{ display: 'flex', justifyContent: 'center', margin: '5px 0px' }}
          >
            <Grid item xs={4}>
              <Typography variant="subheading">
                {' '}
                <b>Phone</b>{' '}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="subheading">{docuRes.supportPhone || ''}</Typography>
            </Grid>
          </Grid>
          <Grid
            container
            item
            xs={12}
            style={{ display: 'flex', justifyContent: 'center', margin: '5px 0px' }}
          >
            <Grid item xs={4}>
              <Typography variant="subheading">
                {' '}
                <b>Monday - Friday</b>{' '}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="subheading">{docuRes.supportWeekSchedule || ''}</Typography>
            </Grid>
          </Grid>
          <Grid
            container
            item
            xs={12}
            style={{ display: 'flex', justifyContent: 'center', margin: '5px 0px' }}
          >
            <Grid item xs={4}>
              <Typography variant="subheading">
                {' '}
                <b>Saturday - Sunday</b>{' '}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="subheading">{docuRes.supportWeekendSchedule || ''}</Typography>
            </Grid>
          </Grid>
        </Grid>
      </ModalDialog>
    )
  }
}

export default ForwardRefHOC(DocusignNotificationModal)



// WEBPACK FOOTER //
// ./src/components/Modal/DocusignNotificationModal.js